<div class="std-ta-center">
  <div nxModalContent>
    <h3 nxHeadline="subsection-large" class="nx-margin-bottom-m">
      Failed
    </h3>
    <p nxCopytext="normal" class="nx-margin-bottom-m">
      {{ txt }}
    </p>
  </div>
  <button type="button" (click)="onclickOK()" nxButton="primary">Close</button>
</div>